// Import Footer Components
import { setFlexBasis } from './components/footer/setFlexBasis.js';
import { navicon } from './components/footer/navicon.js';
import { timelineScroll } from './components/footer/timelineScroll.js';
import { activitiesExpand } from './components/footer/activitiesExpand.js';
import { contentExpand } from './components/footer/contentExpand.js';
import { updateHeaderHeightVariables } from "./components/footer/updateHeaderHeightVars.js";
import { cookieCompliance } from "./components/footer/cookieCompliance.js";
import { carousels } from "./components/footer/carousels.js";
import { navigation } from "./components/footer/navigation.js";
import { farloUiCrmSignup } from "./components/footer/farloUiCrmSignup.js";
import { faqs } from './components/footer/faqs.js';
import { keyStages } from './components/footer/keyStages.js';
import { handleSecondaryMenuScroll } from './components/footer/handleSecondaryMenuScroll.js';
import { smoothScroll } from './components/footer/smoothScroll.js';
import { handleSearchNavicon } from './components/footer/handleSearchNavicon.js';
import { searchHandler } from './components/footer/searchHandler.js';
import { elementInView } from './components/footer/elementInView.js';
import { newsFilter, filterPosts } from './components/footer/newsFilter.js';
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { transformLargeNumberList } from './components/footer/transformLargeNumberList.js';
import { formHandling } from './components/footer/formHandling.js';
import { mapBlock } from './components/footer/mapBlock.js';
import { addStylesToVisibleWidget } from './components/footer/addStylesToVisibleWidget.js';
import { addDownloadAttribute } from './components/footer/addDownloadAttribute.js';



((document, window, history) => {


	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};



	document.addEventListener('DOMContentLoaded', () => {

		updateHeaderHeightVariables();

		// Call the function whenever the window is resized
		window.addEventListener('resize', updateHeaderHeightVariables);

		if (document.querySelector('.gfield')){
			formHandling();
		}

		if (document.querySelector('.map-block__interactive')){
			mapBlock();
		}

		if (document.querySelector('.is-style-download')){
			addDownloadAttribute();
		}


		addStylesToVisibleWidget();
		
		if (document.querySelector('.menu-item')){
			setFlexBasis();
		}
		if (document.querySelector('.site-header')){

			addScrolledClass();
		}
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-header__search')){
			searchHandler();
		}

		if (document.querySelector('.site-page-post__search')){
			filterPosts();
			newsFilter();
		}

		if (document.querySelector('.is-style-large-number')) {
			transformLargeNumberList();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.secondary-menu')){
			handleSecondaryMenuScroll();
		}

		if (document.querySelector('.activities__list-item')) {
			activitiesExpand();
		}


		if (document.querySelector('.timeline')) {
			timelineScroll();
		}

		if (document.querySelector('.site-header__search')){
			handleSearchNavicon();
		}

		if (document.querySelector('.collapse-content-block')){
			contentExpand();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			 smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.site-activity__key-stages')) {
			keyStages();
		}

		if (document.querySelector('.site-carousel')) {
			document.querySelectorAll('.site-carousel').forEach((_sel) => {
				carousels(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-animated')) {
			document.querySelectorAll('.site-farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm__toggle')) {
			document.querySelectorAll('.site-farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.site-farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}
	});

	window.addEventListener('load', () => {
		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				if(_sel.classList.contains('site-farlo-ui-revolver-carousel--autoplay')) {
					_sel.farloUiRevolverCarouselAutoplay();
				} else {
					_sel.farloUiRevolverCarousel();
				}
				
			});
		}
	});



	
})(document, window, history);
